import { EmptyState } from "src/components/EmptyState"
import { ParadiseBarChart } from "src/components/Paradise/ParadiseCharts/ParadiseBarChart"
import { ParadiseLineChart } from "src/components/Paradise/ParadiseCharts/ParadiseLineChart"
import { useParadiseDeviceReadings } from "src/components/Paradise/ParadiseDevices/ParadiseDeviceReadings/useParadiseDeviceReadings"
import { LoadingWrapper } from "src/components/Paradise/sharedStyles"
import { DeviceReadingType } from "src/data/devices/types/deviceTypes"
import { MCircularProgress } from "src/ui/MCircularProgress/MCircularProgress"

export function ParadiseDeviceReadingsGraph({
  deviceId,
  type,
  dateRange,
}: {
  deviceId: string
  type: DeviceReadingType
  dateRange: { startAt: Date; endAt: Date }
}) {
  const deviceReadings = useParadiseDeviceReadings({
    deviceId,
    type,
    dateRange,
  })

  if (deviceReadings.isLoading) {
    return (
      <LoadingWrapper>
        <MCircularProgress />
      </LoadingWrapper>
    )
  }

  if (
    type === "motion_events" &&
    hasReadings(deviceReadings.motionReadings?.values)
  ) {
    return (
      <ParadiseBarChart
        data={deviceReadings.motionReadings?.values}
        tooltip={{ unit: "" }}
        canExport
        zoom="xy"
      />
    )
  }

  if (hasReadings(deviceReadings.dashboardReadings)) {
    return (
      <ParadiseLineChart
        data={deviceReadings.dashboardReadings}
        tooltip={{ unit: "" }}
        canExport
        smooth={false}
        zoom="xy"
      />
    )
  }

  if (hasReadings(deviceReadings.readings?.values)) {
    return (
      <ParadiseLineChart
        data={deviceReadings.readings.values}
        tooltip={{ unit: "" }}
        canExport
        smooth={false}
        zoom="xy"
      />
    )
  }

  return <EmptyState icon={<></>} title="No readings available" />
}

function hasReadings<Type extends unknown[]>(
  readings: Type | undefined
): readings is Type {
  if (readings && readings.length > 0) {
    return true
  }

  return false
}
